<!--
* UIID: UI-DLB-ID-110, 120
* UI Name: Add user
* Modify Date: 2020/06/18
-->
<template>
  <v-dialog v-model="dialog"
    max-width="888px"
    persistent
  >
    <v-card class="title-header-company">
      <v-card-title class="content-header-company ml-3 mr-5 py-3">
        <span class="headline white--text">{{$t('lbl.users.myAccount.header')}}</span><v-spacer></v-spacer>
        <span class="headline white--text"><v-btn small text icon @click="close()">
        <icon-svg iconName="close" />
      </v-btn></span>
      </v-card-title>
    </v-card>
    <v-card class="v-dialog-1 dialog-company-Detail add-map-layout-dialog">
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="6" class="mt-0 mb-0 pt-0 pb-0 text-base">
            <v-label> {{$t('lbl.users.myAccount.userInformation')}} </v-label>
          </v-col>
          <v-col cols="6" class="mt-0 mb-0 pt-0 pb-0 text-base">
            <v-label> {{$t('lbl.users.myAccount.changePassword')}} </v-label>
          </v-col>

          <v-col cols="6">
            <v-form
              ref="form1"
              class="dialog-content form-identification form-company"
              style="height: 391px;"
            >
              <v-row class="ml-0 mr-0">
                <v-col cols="12" class="pl-0 pr-0">
                  <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>{{$t('lbl.users.myAccount.name')}}</v-label>
                  <v-text-field
                    ref="usrNm"
                    v-model="value.usrNm"
                    dense
                    class="text-field-company"
                    :rules="[validationUtils.required, validationUtils.max(50)]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mt-3">
                <v-col cols="12" class="pl-0 pr-0">
                  <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>{{$t('lbl.users.myAccount.phone')}}</v-label>
                  <v-text-field
                    ref="compTelNo"
                    v-model="value.compTelNo"
                    class="text-field-company"
                    dense
                    :rules="[validationUtils.required, validationUtils.max(50)]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mt-0">
                <v-col cols="7" class="pl-0 pr-0">
                  <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>{{$t('lbl.users.myAccount.country')}}</v-label>
                  <v-select
                    ref="langTpCd"
                    v-model="value.langTpCd"
                    dense
                    :items="langTpCdList"
                    class="custom-selectbox text-field-company"
                    :menu-props="{ offsetY: true, }"
                    :rules="[validationUtils.required, validationUtils.max(50)]"
                  ></v-select>
                </v-col>
                <v-col cols="5" class="pl-2 pr-0">
                  <v-label><v-icon x-small class="mr-1">fa fa-asterisk</v-icon>{{$t('lbl.users.myAccount.timeZone')}}</v-label>
                  <v-select
                    ref="gmtTmznCd"
                    v-model="value.gmtTmznCd"
                    :items="gmtTmznCdList"
                    dense
                    class="custom-selectbox text-field-company"
                    :menu-props="{ offsetY: true, }"
                    :rules="[validationUtils.required, validationUtils.max(50)]"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mt-0">
                <v-col cols="7" class="pl-0 pr-0">
                  <v-label>{{$t('lbl.users.myAccount.role')}}</v-label>
                  <v-select
                    ref="useGrdCd"
                    v-model="value.useGrdCd"
                    :items="useGrdCdList"
                    dense
                    class="custom-selectbox text-field-company"
                    :menu-props="{ offsetY: true, }"
                  ></v-select>
                </v-col>
                <v-col cols="5" class="pl-2 pr-0">
                  <v-label>{{$t('lbl.users.myAccount.screenTheme')}}</v-label>
                  <v-select
                    ref="themeScreen"
                    v-model="value.selUiThmCd"
                    :items="themeScreen"
                    dense
                    class="custom-selectbox text-field-company"
                    :menu-props="{ offsetY: true, }"
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-col>

          <v-col cols="6">
            <v-form
              ref="form2"
              class="dialog-content form-identification form-company"
              style="height: 391px;"
            >
              <v-row class="ml-0 mr-0">
                <v-col cols="12" class="pl-0 pr-0">
                  <v-label>{{$t('lbl.users.myAccount.oldPassword')}}</v-label>
                  <v-text-field
                    ref="oldUsrPwd"
                    v-model="pwdChg.oldUsrPwd"
                    :rules="[pwdChg.oldUsrPwd === '' && pwdChg.newUsrPwd === '' && pwdChg.cfmNewUsrPwd === '' ? false : validationUtils.required]"
                    dense
                    class="text-field-company"
                    type="password"
                    @blur="checkPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mt-6">
                <v-col cols="12" class="pl-0 pr-0">
                  <div><v-label>{{$t('lbl.users.myAccount.newPassword')}}</v-label></div>
                  <div class="d-inline-flex col-12 pl-0 pr-0">
                    <v-text-field
                      class="text-field-company"
                      ref="newUsrPwd"
                      v-model="pwdChg.newUsrPwd"
                      :rules="[pwdChg.oldUsrPwd === '' && pwdChg.newUsrPwd === '' && pwdChg.cfmNewUsrPwd === '' ? true : validationUtils.passwordRules]"
                      dense
                      type="password"
                      @blur="checkPassword"
                      :maxlength="20"
                    ></v-text-field>
                    <v-tooltip top :max-width="tooltipWidth" style="questionToolTip">
                      <template v-slot:activator="{ on}">
                        <div v-on="on">
                          <v-icon class="btn-tooltip-pw pt-3 pl-2">
                            far fa-question-circle
                          </v-icon>
                        </div>
                      </template>
                      <span  v-html="$t('msg.users.questionIconTooltip')">
                      </span>
                    </v-tooltip>
                  </div>
                </v-col>
              </v-row>
              <v-row class="ml-0 mr-0 mt-6">
                <v-col cols="12" class="pl-0 pr-0">
                  <v-label>{{$t('lbl.users.myAccount.confirmNewPassword')}}</v-label>
                  <v-text-field
                    ref="cfmNewUsrPwd"
                    v-model="pwdChg.cfmNewUsrPwd"
                    :rules="[pwdChg.oldUsrPwd === '' && pwdChg.newUsrPwd === '' && pwdChg.cfmNewUsrPwd === '' ? true : validationUtils.required]"
                    class="text-field-company"
                    dense
                    type="password"
                    @blur="checkPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
        <v-divider class="ml-0 mr-0 mt-3 divder-popup" inset></v-divider>
      </v-card-text>
      <v-row class="ml-0 mr-0 pt-2">
        <v-col class="button-col action-col px-0" lg="12">
          <div class="btn-form-control text-right">
            <v-btn class="btn btn-delete btn-popup" @click="close()">
              {{$t('btn.common.close')}}
            </v-btn>
            <v-btn class="btn btn-popup-search btn-popup" color="primary" @click="save()">
              {{$t('btn.common.save')}}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <!-- [E]  Popup body-->
    <dialogWindow
      ref="addUserDialog"
      size="max"
      :detail="dialogInfo"
      :color="dialogColor"
      @select-ok="closeDialog()"
    >
    </dialogWindow>
    <dialogWindow
      ref="uploadUserDialog"
      size="max"
      :detail="dialogInfo"
      :color="dialogColor"
      @select-ok="reloadPage()"
    >
    </dialogWindow>
  </v-dialog>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import IconSvg from "@/vue-caas/components/IconBase.vue";

export default {
  components: {
    dialogWindow,
    IconSvg,
  },
  data: () => ({
    dialog: false,
    value: {},
    pwdChg: {
      oldUsrPwd: '',
      newUsrPwd: '',
      cfmNewUsrPwd: '',
    },
    gmtTmznCdList: [],
    useGrdCdList: [],
    langTpCdList: [],
    dialogInfo: '',
    dialogColor: 'validation',
    tooltipWidth: 300,
    themeScreen: [
      { text: "Dark", value: "dark" },
      { text: "Light", value: "light" }
    ],
  }),
  created() {
    // User Role
    this.$store.dispatch('caascommon/getComCdRoleList', { grpCd: 'C02' }).then(() => {
      this.useGrdCdList = this.$store.getters['caascommon/comCdList'];
    });

    // GMT Timezone
    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'C04' }).then(() => {
      this.gmtTmznCdList = this.$store.getters['caascommon/comCdList'];
    });

    // Language Type Code
    this.$store.dispatch('caascommon/getComCdList', { grpCd: 'C05' }).then(() => {
      this.langTpCdList = this.$store.getters['caascommon/comCdList'];
    });

    this.$store.dispatch('getUser', { usrId: this.$cookies.get('user-id') }).then(() => {
      this.value.usrId = this.$store.getters.user.usrId;
      this.value.usrNm = this.$store.getters.user.usrNm;
      this.value.compTelNo = this.$store.getters.user.compTelNo;
      this.value.langTpCd = this.$store.getters.user.langTpCd;
      this.value.gmtTmznCd = this.$store.getters.user.gmtTmznCd;
      this.value.useGrdCd = this.$store.getters.user.useGrdCd;
      this.value.selUiThmCd = this.$store.getters.user.selUiThmCd;

      for (let i = this.useGrdCdList.length - 1; i >= 0; i -= 1) {
        const val = this.useGrdCdList[i].value;
        if (this.value.useGrdCd < val) {
          this.useGrdCdList.splice(i, 1);
        }
      }
    });
  },
  methods: {
    save() {
      if (this.pwdChg.oldUsrPwd !== '' && this.pwdChg.newUsrPwd !== '' && this.pwdChg.cfmNewUsrPwd !== '') {
        this.$store.dispatch('checkPassword', { usrPwd: this.pwdChg.oldUsrPwd }).then(() => {
          const resultPwd = this.$store.getters.user;
          if (resultPwd.usrId === undefined) {
            this.$refs.addUserDialog.dialog = true;
            this.dialogInfo = 'Invalid old password.';
            this.dialogColor = 'validation';
          } else {
            if (this.pwdChg.newUsrPwd === this.pwdChg.cfmNewUsrPwd) {
              this.value.usrPwd = this.pwdChg.newUsrPwd;
              this._updateMyAcc();
            } else {
              this.$refs.addUserDialog.dialog = true;
              this.dialogInfo = 'Different each new password. Please check new password.';
              this.dialogColor = 'validation';
            }
          }
        }).catch((err) => {
          this.$refs.addUserDialog.dialog = true;
          this.dialogInfo = `Exception occured during check password. (Reason: ${err.message})`;
          this.dialogColor = 'error';
        });
      } else if (this.pwdChg.oldUsrPwd === '' && this.pwdChg.newUsrPwd === '' && this.pwdChg.cfmNewUsrPwd === '') {
        this._updateMyAcc();
      } else {
        this.checkPassword();
      }
    },
  _updateMyAcc() {
      this.$store.dispatch('updateMyAcc', this.value).then(() => {
        this.value = this.$store.getters.user;
        this.$cookies.set('hash', this.value.hash, '12h');
        this.$cookies.set('user-name', this.value.usrNm, '12h');
        this.$cookies.set('ui-theme', this.value.selUiThmCd, '12h');
        this.$cookies.set('gmt-timezone', this.value.gmtTmznCd, '12h');
        this.$cookies.set('country-code', this.value.langTpCd, '12h');
        this.$cookies.set('use-grade', this.value.useGrdCd, '12h');

        this.$refs.uploadUserDialog.dialog = true;
        this.dialogInfo = this.$t('msg.users.clickBtnSaveMyAccount');
        this.dialogColor = 'success';
      }).catch((err) => {
        this.$refs.addUserDialog.dialog = true;
        this.dialogInfo = `Exception occured during save my account info. (Reason: ${err.message})`;
        this.dialogColor = 'error';
      });
    },
    reloadPage() {
      window.location.reload();
    },
    close() {
      this.dialog = false;
    },
    closeDialog() {
      this.$refs.addUserDialog.dialog = false;
      this.pwdChg.oldUsrPwd = '';
      this.pwdChg.newUsrPwd = '';
      this.pwdChg.cfmNewUsrPwd = '';
      this.value.usrPwd = undefined;
      this.dialog = false;
    },
    checkPassword() {
      if ((this.pwdChg.oldUsrPwd === '' || this.pwdChg.oldUsrPwd === undefined)
        && (this.pwdChg.newUsrPwd === '' || this.pwdChg.newUsrPwd === undefined)
        && (this.pwdChg.cfmNewUsrPwd === '' || this.pwdChg.cfmNewUsrPwd === undefined)) {
        this.$refs.oldUsrPwd.reset();
        this.$refs.newUsrPwd.reset();
        this.$refs.cfmNewUsrPwd.reset();
      } else {
        this.$refs.oldUsrPwd.validate(true);
        this.$refs.newUsrPwd.validate(true);
        this.$refs.cfmNewUsrPwd.validate(true);
      }
    },
  },
}
</script>